import { render, staticRenderFns } from "./hot-merchant.vue?vue&type=template&id=60c1fd13&scoped=true"
import script from "./hot-merchant.vue?vue&type=script&lang=ts&setup=true"
export * from "./hot-merchant.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./hot-merchant.vue?vue&type=style&index=0&id=60c1fd13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1fd13",
  null
  
)

export default component.exports